var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"headline"},[_c('h2',[_vm._v(_vm._s(_vm.data))])]),_vm._v(" "),_c('div',{staticClass:"text-center buttons-close"},[_c('a',{on:{"click":function($event){return _vm.closeModal()}}},[_vm._v("Luk")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30adbdfc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/map/plain-information-modal.vue
// module id = null
// module chunks = 